// Aviso.jsx
import styles from './aviso.module.css';
import { BsDatabaseDown } from 'react-icons/bs';
import { FiX } from 'react-icons/fi';

function Aviso({ mensagem, botaoTexto2, botaoTexto1, onBotaoClick2, onBotaoClick1, onClose, pagina }) {
  return (
    <div className={styles['aviso-container']} role="dialog" aria-modal="true" aria-label="Aviso">
      <div className={styles['aviso-mensagem']}>
        <button
          type="button"
          className={styles['aviso-close']}
          onClick={onClose}
          aria-label="Fechar aviso"
        >
          <FiX size={18} />
        </button>
        <div className={styles['aviso-header']}>
          <BsDatabaseDown className={styles['aviso-icon']} />
          <h3>Ops, nada por aqui</h3>
        </div>
        <div className={styles['aviso-body']}>
          <p>{mensagem}</p>
        </div>
        <div className={styles['aviso-actions']}>
          {botaoTexto1 && (
            <button type="button" onClick={onBotaoClick1} className={`${styles['aviso-btn']} ${styles['aviso-btn--primary']}`}>
              {botaoTexto1}
            </button>
          )}
          {botaoTexto2 && (
            <button type="button" onClick={onBotaoClick2} className={`${styles['aviso-btn']} ${styles['aviso-btn--secondary']}`}>
              {botaoTexto2}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Aviso;
